































































import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/assets/logo.svg';
import Icon from '@/components/Icon.vue';
import variables from '@/support/variables';

@Component({
  components: {
    Icon,
    Logo,
  },
})
export default class Footer extends Vue {
  get variables() {
    return variables;
  }
}
